import type { Text as TextType } from 'types/capi/content';

import Links from './Links';
import PlainText from './PlainText';

const Text = ({ item }: { item: TextType }) => {
  switch (item.type) {
    case 'text':
      return <PlainText item={item} />;
    case 'internal':
      return <Links.Internal preventPropagation link={item} />;
    case 'external':
      return <Links.External preventPropagation link={item} />;
    default:
      return null;
  }
};

export default Text;
